import { render, staticRenderFns } from "./DepartmentSummary.vue?vue&type=template&id=2369d10e&scoped=true&"
import script from "./DepartmentSummary.vue?vue&type=script&lang=js&"
export * from "./DepartmentSummary.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentSummary.vue?vue&type=style&index=0&id=2369d10e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2369d10e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VContainer,VDataTable,VProgressLinear,VSelect})
